import React from "react";
import Slider from "react-slick";

const Gallery = ({ data }) => {
  const parseURL = (ref) => {
    if (ref) {
      const split = ref.split("-");

      if (split.length === 4) {
        return `https://cdn.sanity.io/images/eo9g5l50/production/${split[1]}-${split[2]}.${split[3]}`;
      }
      return "";
    } else {
      return "";
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      {/* <h2 className="text-3xl font-bold text-center mb-8">Our Portfolio</h2> */}
      <div className="gallery-slider">
        <Slider {...settings}>
          {data.map((item, index) => (
            <div key={index} className="outline-none">
              <div className="relative h-[500px] md:h-[600px]">
                <img
                  src={parseURL(item.image.asset._ref)}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 p-4 text-white">
                  <h3 className="text-xl md:text-2xl font-semibold">
                    {item.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Gallery;
